import React from 'react';
import { AlertCircle, ArrowLeft } from 'lucide-react';
import IntegritasBtn from './IntegritasBtn';

interface GoogleAuthErrProps {
  error: string;
  onRetry?: () => void;
  isOverlay?: boolean;
}

const GoogleAuthErr = ({ error, onRetry, isOverlay = false }: GoogleAuthErrProps) => {
  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    }
  };

  const content = (
    <div className="flex flex-col items-center justify-center gap-10">
      <IntegritasBtn />
      <div className="bg-gradient-to-t from-black to-[#131313] w-full min-w-[425px] lg:min-w-[525px] rounded-lg border border-[#1B1B1B] shadow-lg p-10 relative">
        <div className="flex flex-col items-center text-center gap-6">
          <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center">
            <AlertCircle className="w-8 h-8 text-red-500" />
          </div>

          <div className="space-y-2">
            <h2 className="font-normal text-xl text-center">Authentication Failed</h2>
            <p className="text-muted-foreground text-sm max-w-sm">
              Google authentication failed. Please try again or use email login.
            </p>
          </div>

          <div className="flex flex-col gap-3 w-full">
            <button
              onClick={handleRetry}
              className="border border-[#1B1B1B] text-sm text-minima-orange-2023 shadow-xs hover:bg-minima-orange-2023 hover:border-minima-orange-2023 hover:text-black h-9 px-4 py-2 w-full flex items-center justify-center gap-2 cursor-pointer rounded"
            >
              <ArrowLeft className="w-4 h-4" />
              Try Again
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  if (isOverlay) {
    return content;
  }

  return (
    <div className="bg-black min-h-screen flex items-center justify-center z-50 p-4">{content}</div>
  );
};

export default GoogleAuthErr;
